// Vibration patterns (ms) for phones that support it. Every pattern is skipped under reduced motion.

export const HAPTIC = {
  /** a cylinder was accepted by the reader */
  scan: 25,
  /** a load or unload was started */
  start: 30,
  /** a cylinder was registered */
  saved: 40,
  /** departed / receipt finished */
  done: [40, 40, 80],
  /** a cylinder that must not be loaded */
  reject: [120, 60, 120],
  /** a tag that is not part of the shipment being unloaded */
  extra: [80, 40, 80],
} as const;
